import React, { useState } from 'react';

function MergeSortControls({ onStart }) {
  const [inputArray, setInputArray] = useState('');

  const handleStart = () => {
    const array = inputArray.split(',').map(Number);
    onStart(array);
  };

  const handlePredefinedData = () => {
    const predefinedArray = [38, 27, 43, 3, 9, 82, 10];
    onStart(predefinedArray);
  };

  return (
    <div className="controls">
      <h2>Merge Sort Visualizer</h2>
      <div>
        <label>
          Array (comma separated):
          <input
            type="text"
            value={inputArray}
            onChange={(e) => setInputArray(e.target.value)}
          />
        </label>
      </div>
      <button onClick={handleStart}>Start Sort</button>
      <button onClick={handlePredefinedData}>Use Predefined Data</button>
    </div>
  );
}

export default MergeSortControls;
